/* eslint-disable max-classes-per-file */
import axios from 'axios';
import authStore from '@/store/auth';
import env from '@/utils/env';
import getRiskParamFn from '@/utils/getRiskParamFn';
import config, { getSysTag } from '@/const/app.const';
import log from '@/utils/log';
import toast from '@/components/toast';
import Native from '@/utils/nativeProxy/index';
import UBT from '@/utils/ubt';
import param from '@/utils/param';

const CODE_MAPS = {
  101: '系统错误',
  102: '缺少参数',
  103: 'invalid token',
  104: '非法参数',
  801: '手机号无效',
  802: '亲，您已经参与过活动了，不要贪心哟！',
  803: '老用户',
  804: '已无优惠券',
  901: 'go back',
};

// 风控参数promise缓存
let riskControlDataPromise = null;

async function getRiskParam() {
  if (!riskControlDataPromise) {
    riskControlDataPromise = getRiskParamFn();
  }
  return riskControlDataPromise;
}

async function encodeRequestData(data, needLogin) {
  const riskControlData = await getRiskParam();
  const mergedData = { ...data, riskControlData };

  if (!needLogin) {
    return Promise.resolve(mergedData);
  }
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      if (mergedData.token && mergedData.ticket) {
        resolve(mergedData);
      } else {
        const { token, ticket } = await Native.getTokenAndKey();
        if (token && ticket) {
          resolve(Object.assign(mergedData, { token, ticket }));
        } else {
          resolve(Object.assign(mergedData, { token }));
        }
      }
    } catch (e) {
      reject(e);
      // eslint-disable-next-line no-console
      console.log(e);
    }
  });
}

export class CustomError extends Error {
  constructor({
    message,
    response,
    error,
    serverError,
  }) {
    super(message);
    this.message = message;
    this.error = error;
    this.response = response;
    this.serverError = serverError;
    this.name = 'CustomError';
  }
}

export default class Request {
  static base(type, data, options, needLogin) {
    return new Promise((resolve, reject) => {
      const requestData = {
        version: env.mpVersion || env.appVersion,
        from: 'h5',
        systemCode: env.systemCode,
        platform: 63,
        __sysTag: getSysTag(),
        ...data,
      };

      const { useNativePreRequest } = options;
      // eslint-disable-next-line
        delete options.useNativePreRequest;
      const requestOptions = { timeout: 0, ...options };

      const action = requestData.action || '';
      if (action.indexOf('&') !== -1) {
        requestData.action = action.substring(0, action.indexOf('&'));
      }
      encodeRequestData(requestData, needLogin).then((encodeData) => {
        const apiServer = (options && options.apiServer) || config.BASE_API;
        if (options && options['Content-Type']) {
          if (!requestOptions.headers) {
            requestOptions.headers = {};
          }
          requestOptions.headers['Content-Type'] = options['Content-Type'];
          if (options && options.paramsSerializer && typeof options.paramsSerializer === 'function') {
            requestOptions.paramsSerializer = options.paramsSerializer;
          }
        }

        try {
          const useNativePreRequestGrey = param.get('native_request');
          if (+useNativePreRequestGrey === 1 && useNativePreRequest) {
            if (!requestOptions.headers) {
              requestOptions.headers = {};
            }
            requestOptions.headers.__native_request_value__ = '1';
          }
        } catch (e) {
          // eslint-disable-next-line
          console.log(e);
        }

        const axiosPromise = type === 'get' ? axios[type](`${apiServer}?${action}`, {
          params: encodeData,
          ...requestOptions,
        }) : axios[type](`${apiServer}?${action}`, encodeData, requestOptions);
        axiosPromise.then((res) => {
          const responseData = res.data;
          const { code } = responseData;
          if (code === 0) {
            resolve(responseData);
          } else if (code === 103) {
            authStore.reset();

            const err = new CustomError({
              message: '登录信息失效, 请重新登录',
              response: res,
            });
            reject(err);

            toast.showError(err)
              .then(() => {
              });
          } else {
            let { msg } = responseData;
            let codeMsg = CODE_MAPS[code];
            if (!codeMsg) {
              codeMsg = `unknow code ${code}!`;
            }
            msg = msg || codeMsg;

            reject(new CustomError({
              message: msg,
              response: res,
              error: true,
            }));
          }
        })
          .catch((ex) => {
            const errorInfo = {
              action: requestData && requestData.action,
              apiServer,
              requestUrl: requestData.action || requestData.apiServer,
              errorMessage: ex && ex.message,
              errorCode: ex && ex.code,
            };
            UBT.send({
              ...errorInfo,
              keyword: 'network_error_hitch',
              message: ex && JSON.stringify(ex),
            });
            if (window.TianQi && window.TianQi.UBT) {
              window.TianQi.UBT.customEventWithPointId({
                pointId: 'network_error_hitch',
                businessInfo: {
                  ...errorInfo,
                  error: ex && JSON.stringify(ex),
                },
              });
            }
            if (axios.isCancel(ex)) {
              log.warn('请求被取消');
            } else {
              reject(new CustomError({
                message: '网络异常，请稍后重试',
                error: true,
                serverError: true,
              }));
            }
          });
      }, reject);
    });
  }

  static post(data, options, needLogin = false) {
    if (process.env.NODE_ENV !== 'pro') {
      // console.log(data);
    }
    return Request.base('post', data, options || {}, needLogin);
  }

  static get(data, options) {
    return Request.base('get', data, options || {});
  }
}
